import validateHelpers from '../../utils/validations';

export default {
  appId: validateHelpers.required(),
  appKey: validateHelpers.required(),
  graphqlUri: validateHelpers.required(),
};
